import CancellationPolicy from './CancellationPolicy.container';

export default CancellationPolicy;
